module.exports = "pegasus_template/assets/themelp1/creative/102.png";